<template>
    <div>   
      <v-col cols="12">
        <v-row class="button1">
            <v-tabs           
            background-color="transparent"
            centered
            color=" var(--v-primary-darken2)"
            >
              <v-tab background-color="transparent" @click="change(true)">{{ $t("results.analysis.backup_review") }}</v-tab>
              <v-tab @click="change(false)">{{ $t("results.analysis.scores_statistics") }}</v-tab>

            </v-tabs>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="12">
            <v-row v-if="pag" class="pag1 px-md-0 px-4">
              <v-row class="tabulador">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="4" class="ml-auto">
                      <v-btn @click="confirmProcessBackups" class="ml-auto mt-sm-3" :loading="loadingProcess">
                        {{ $t("results.analysis.process_backups") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col class="d-flex racesCompClass" cols="12" md="4" sm="4">
                        <v-autocomplete
                          v-model="selectedRaces"
                          :items="items"
                          item-text="name"
                          :label="$t('results.analysis.races')"
                          outlined
                          :clearable="true"
                          :small-chips="true" dense
                          return-object
                          :no-data-text="$t('common.no_data')"
                        >
                          <template v-slot:selection="{ item, index }">
                            <span v-if="index < 1" class="grey--text caption">
                              {{ item.name }}
                            </span>
                          </template>
                        </v-autocomplete>
                    </v-col> 
                    <v-col class="d-flex" cols="12" md="4" sm="4">
                        <v-text-field
                          v-model="interval"
                          :outlined="true"
                          :messages="$t('results.analysis.interval_messages')"
                          :label="$t('results.analysis.interval')"
                          type="number"
                          @keypress="isNumber($event)"
                          max="86400"
                          :rules="rules"
                          hide-details="auto"
                          dense
                          v-on:blur="editInterval"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col  cols="12" md="4" sm="4">
                      <v-btn tile @click="filteredScores_" class="float-left ml-sm-4">
                          <v-icon left>
                            fas fa-sync
                          </v-icon>
                          {{ $t("results.analysis.compare") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col> 
                <v-col class="d-flex" cols="12" sm="12" style="position:relative;" >
                  <VueTabulator
                    ref="tabulator"
                    v-model="filteredScores"
                    :options="tabulatorOptions"
                    key="refresh"
                    style="width: 100%"
                  />
                  <div v-if="!isLoadData"
                    style='position: absolute;
                          left: 40%;
                          top: 57%;border:4px solid #333; border-radius:10px; background:#fff; font-weight:bold; font-size:16px; color:#000; padding:10px 20px;'>
                          {{ $t("page.race-scores.loading")}}

                  </div>
                </v-col>
              </v-row>
              <SGSNotificationAlert 
                :snackbar="alert" :notificationMessage="$t('results.analysis.alert')" @cancel="alertColor" 
                type="warning" :right="true" :top="true" class="alert"
              />
              <SGSNotificationAlert 
                class="alert" :snackbar="alertFormat" :notificationMessage="$t('results.analysis.format')" @cancel="alertFormat=false" 
                type="warning" :right="true" :top="true" 
              />
              <SGSNotificationAlert 
                class="alert" :snackbar="alertNoFormat" :notificationMessage="$t('results.analysis.no_format')" @cancel="alertNoFormat=false" 
                type="warning" :right="true" :top="true" 
              />
              <SGSNotificationAlert 
                class="alert" :snackbar="error!=''" :notificationMessage="error" @cancel="error=''" 
                type="warning" :right="true" :top="true" 
              />
              <SGSNotificationAlert 
                class="alert" :snackbar="alertNotYourRace" :notificationMessage="$t('results.analysis.not_your_race')" @cancel="alertNotYourRace=false" 
                type="warning" :right="true" :top="true" 
              />
              <SGSNotificationAlert 
                class="alert" :snackbar="alertInvalidScore" 
                :notificationMessage="$t('results.analysis.invalid_score', {RaceId: this.raceIdError, invalid_time: this.invalidTime})" 
                @cancel="alertInvalidScore=false" type="warning" :right="true" :top="true" 
              />
              <SGSNotificationConfirm 
                v-if="confirmBand" :notificationMessage="$t('results.analysis.confirm_process_backup')" 
                small @agree="processBackups" @cancel="confirmBand = false" type="warning"
              />
            </v-row>
            <v-row v-if="!pag" class="pag2">
                <v-col md="6" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                  <v-card-title>
                    {{ $t("results.analysis.score_statistics.score_by_score_type")}}
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search1"
                      append-icon="mdi-magnify"
                      :label="$t('common.search')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      :headers="headersT1"
                      :items="ScoreType"
                      :items-per-page="5"
                      :search="search1"
                      :footer-props="{
                          'items-per-page-text': $t('dataTable.rowsPerPageText'),
                          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                      }"
                      :no-data-text="$t('dataTable.noDataText')"
                      :headerProps="{
                          'sort-by-text': $t('dataTable.sortByText')
                      }"
                  ></v-data-table>
                </v-col>
                  <br>
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <v-card-title>
                    {{ $t("results.analysis.score_statistics.score_check")}}
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search2"
                      append-icon="mdi-magnify"
                      :label="$t('common.search')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                    <v-data-table
                        :headers="headersT2"
                        :items="CheckNumber"
                        :items-per-page="5"
                        :search="search2"
                        :footer-props="{
                          'items-per-page-text': $t('dataTable.rowsPerPageText'),
                          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                        }"
                        :no-data-text="$t('dataTable.noDataText')"
                        :headerProps="{
                          'sort-by-text': $t('dataTable.sortByText')
                        }"
                      ></v-data-table>
                  </v-col>
                  <br>
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <v-card-title>
                    {{ $t("results.analysis.score_statistics.score_race_number")}}
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search3"
                      append-icon="mdi-magnify"
                      :label="$t('common.search')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                    <v-data-table
                        :headers="headersT3"
                        :items="RaceNumber"
                        :items-per-page="5"
                        :search="search3"
                        :footer-props="{
                          'items-per-page-text': $t('dataTable.rowsPerPageText'),
                          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                        }"
                        :no-data-text="$t('dataTable.noDataText')"
                        :headerProps="{
                          'sort-by-text': $t('dataTable.sortByText')
                        }"
                      ></v-data-table>
                  </v-col>
            </v-row>
          </v-col>
        </v-row>
    </v-col>
  </div>
     
</template>
  
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import axios from "axios";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/Alert.vue";

export default {
  mixins: [apiCalls], //for api redundant operations
  components: {
    SGSNotificationAlert, SGSNotificationConfirm
 },
  data() {
    return {
      items: [],
      race:[],
      selectedRaces:[],
      error:'',
      pag:true,
      ScoreType:{},
      CheckNumber:{},
      RaceNumber:{},
      interval: 0,
      search1: '',
      search2: '',
      search3: '',
      intervalGet: 0,
      isLoadData: true,
      lap_section:false,
      alert: false,
      alertFormat:false,
      alertNoFormat:false,
      alertNotYourRace:false,
      alertInvalidScore:false,
      refresh: 0,
      raceIdError: '',
      invalidTime: '',
      check:false,
      filteredScores: [],
      backupAutomatic: false,
      loadingProcess: false,
      confirmBand: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.session.session.userSession
    }),
    headersT1() {
      return [
          {
            text: this.$t("results.analysis.score_statistics.total"),
            value: "total",
          },
          { text: this.$t("results.analysis.score_statistics.score_type"), 
            value: "scoreType" 
          }
      ];
    }, 
    headersT2() {
      return [
          {
            text: this.$t("results.analysis.score_statistics.total"),
            value: "total",
          },
          { text: this.$t("results.analysis.score_statistics.check_number"), 
            value: "lap_section" 
          },
          {
            text: this.$t("results.analysis.score_statistics.device_name"),
            value: "deviceId",
          },
          { text: this.$t("results.analysis.score_statistics.score_type"), 
            value: "scoreType" 
          }
      ];
    },
    headersT3() {
      return [
          {
            text: this.$t("results.analysis.score_statistics.total"),
            value: "total",
          },
          { text: this.$t("results.analysis.score_statistics.race_number"), 
            value: "displayedNumber" 
          },
          { text: this.$t("results.analysis.score_statistics.score_type"), 
            value: "scoreType" 
          }
      ];
    },
    errors() { return this.$t("results.analysis.interval_error"); },
    rules() {
      return [
        value => !!value || this.$t("common.required"),
        value => (value && value <= 86400) || this.$t("results.analysis.interval_error"),
      ];
    },
    tabulatorOptions() {
      return {
        tooltips: true,
        addRowPos: "top",
        height: "600",
        layout: "fitColumns",
        resizableColumns: true,
        placeholder: this.$t("common.no_data_set"),
        columns: [
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            visible: true,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",            
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            visible: true,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.number"),
            field: "displayedNumber",
            visible: false,
            width: "40",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            validator:["required","regex:^[A-Za-z0-9]+$"],
          },
          {
            title: this.$t("common.table.scoreTime"),
            field: "scoreTime",
            visible: true,
            width: "90",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            class: "scoreTime",
            cellEdited: this.scoreTimeEdited
          },
          {
            title: this.$t("common.table.scoreDay"),
            field: "scoreDay",
            visible: true,
            width: "75",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.lap_section"),
            field: "lap_section",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            align: "center"
          },
          {
            title: this.$t("common.table.check"),
            field: "lap_section",
            visible: true,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            align: "center"
          },
          {
            title: this.$t("common.table.sectionType"),
            field: "sectionType",
            visible: true,
            width: "75",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.displayedNumber"),
            field: "displayedNumber",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            align: "center"
          },
          {
            title: this.$t("common.table.class-name"),
            field: "className",
            width: "150",
            visible: true,
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.checkNumberIn"),
            field: "checkNumberIn",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.readTimeIn"),
            field: "readTimeIn",
            visible: false,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            validator: ["required","regex:(1?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9].[0-9]"],
            cellEdited: this.readTimeInEdited
          },
   
          
          {
            title: this.$t("common.table.isThrown"),
            field: "isThrown",
            visible: false,
            width: "35",
            formatter: function (cell) {
              let value = cell.getValue();
              return value !== null
                ? (value === 1 ? '<i style="color:red;" class="fad fa-toilet"></i>'
                : '<i style="color:green;" class="fad fa-toilet"></i>') : ''
            },
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.actions"),
            field: "actions",
            visible: true,
            width: "100",
            headerVertical:'flip',
            columns: [
             {
                title: "",
                field: "edit",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa fa-share'></i>";
                }.bind(this),
                cellClick: this.errorF,
                  
              },
              {
                title: "",
                field: "delete",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-trash'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                    let vm = this
                    this.isLoadData = false;
                    let _data = cell.getRow().getData();
                  
                    axios
                    .delete(
                      `${this.root}/laravel/public/api/v1/promoter/removeParticipantScores/`+_data.participantScoreId
                    ).then(function (response) {
                        if(response.data.success == 1){
                          vm.filteredScores_();
                        }
                    })
                    .catch(function () {
                      //vm.error = vm.$t("results.analysis.error."+err.response.data.message)  
                    });
                }.bind(this),
              },
              
            ],
          },
        ]
      };
    },
  },
  mounted() {
    this.raceBackup()
    this.getInterval()
    this.getBackupAutomatic()
    this.participantScore()
    /*const btn2 = document.getElementsByClassName('btn2');
    if(btn2[0]) btn2[0].style.display = 'contents';*/
    
  },
  methods: {   
    async getEvent(){
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEvent/" +
        this.race.eventId
      );
      if(response.message[0].userId != this.user.id){
        window.location.href = "/admin/promoterDashboard"
        //this.$router.push('PromoterDashboard');
      }
    },
    async raceBackup() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/racesBackup/" +
        this.$route.params.id
      );

      response.message.forEach( value => {
        this.items.push({
          name: `${value.race}  - ${value.raceId}`,
          valor: value.raceId,
          mode: value.mode
        });
      });
      const data = {raceId: this.$route.params.id, force: true};
      const responseRace = await this.api("post", "/api/v1/promoter/race", data);
      
      if(responseRace.success){
        this.race = responseRace.message;
        this.getEvent();
      }
        
        if(this.race.mode == 6 || this.race.mode == 9){
          this.tabulatorOptions.columns[5].visible = true;
          this.tabulatorOptions.columns[6].visible = false;
        }
        if(this.race.mode == 8 || this.race.mode == 10){
          this.tabulatorOptions.columns[5].visible = false 
          this.tabulatorOptions.columns[6].visible = true 
        }
      
    },
    async participantScore(){
      var response = await this.api(
        "get",
        "/api/v1/promoter/totalScoreByScoreType/" +
        this.$route.params.id
      );
        if(response.success == 1){
          this.ScoreType=response.message
        }
      var responseCheck = await this.api(
        "get",
        "/api/v1/promoter/totalScoretypePerCheck/" +
        this.$route.params.id
      );
        if(responseCheck.success == 1){
          this.CheckNumber=responseCheck.message
        }
      var responseRace = await this.api(
        "get",
        "/api/v1/promoter/totalScoretypePerRace/" +
        this.$route.params.id
      );
        if(responseRace.success == 1){
            this.RaceNumber=responseRace.message
        }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async getInterval(){
      var response = await this.api(
        "get",
        "/api/v1/promoter/setting/RaceCompareSeconds" 
      );
      this.interval = response.message
      this.intervalGet = response.message
    },
    async filteredScores_() {
      this.isLoadData = false;
      if(this.selectedRaces.valor){
        this.alert=false
        let vm = this
        axios
        .get(
         `${this.root}/laravel/public/api/v1/promoter/comparator/`+this.selectedRaces.valor
        ).then((response) => {
          let table = this.$refs.tabulator;
          if(table) {
            table.getInstance().setData(response.data.message);
          }
        })
        .catch((err) => {
                if(err.response.data.message=='not_your_race'){
                  vm.alertNotYourRace = true
                }else{
                  const arrayError = err.response.data.message.split("-");
                  if(arrayError[0] == 'invalid_score'){
                    vm.alertInvalidScore = true
                    vm.raceIdError = arrayError[1]
                    vm.invalidTime = arrayError[2]+"-"+arrayError[3]+"-"+arrayError[4]+" "+arrayError[5]
                  }
                }
        });      

      } else {
        this.alert=true
        var class1 = document.getElementsByClassName('racesCompClass')[0].getElementsByClassName('v-input__slot');
        class1[0].className+=" colorAlert"
      }

      this.isLoadData = true;
    },
    change(sent){
        if(sent){
          this.pag = true;
        }
        else{
          this.pag = false;
        }
    },
    errorF(e,cell){
        let vm = this
        this.isLoadData = false;
        let _data = cell.getRow().getData();
        let data = {
          raceId: _data.raceId,
          participantScoreId: _data.participantScoreId
        };
        axios.post(`${this.root}/laravel/public/api/v1/promoter/race/copyScore`, data).then((response) => {
            if(response.data.success == 1){
                vm.filteredScores_();
            }
            if(response.data.success == 0){
                vm.error = vm.$t("results.analysis.error."+response.data.message)  
                vm.isLoadData = true;
            }
        }).catch((err) => {
            vm.error = vm.$t("results.analysis.error."+err.response.data[0].message)  
            vm.isLoadData = true;
        });
                    
    },
    async editInterval() {
      
      if(this.interval != this.intervalGet){
        let data = {
          setting: "RaceCompareSeconds",
          value: this.interval
        }
        const responseInterval =  await this.putApi("/api/v1/promoter/setting", data);

        if(responseInterval.message)
          this.intervalGet =this.interval
      }
     
    },
    async scoreTimeEdited(cell){
      let _data = cell._cell.row.data;
      let data = {
        raceId: _data.raceId,
        participantScoreId: _data.participantScoreId,
        scoreTime: _data.scoreTime 
      }

      var v1= new RegExp("([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]")
      var v2= new RegExp("([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9].[0-9][0-9][0-9]")
      var v3= new RegExp("([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9].[0-9][0-9]")
      var v4= new RegExp("([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9].[0-9]")
      if(data.scoreTime.length == 8){
        if(v1.test(data.scoreTime)){
          const response =  await this.putApi("/api/v1/promoter/score", data);
          if(response.success == 1){
            this.filteredScores_();
          }
        }else{
          this.alertNoFormat = true
          this.filteredScores = ''
          this.filteredScores_();
        }
      }else if(data.scoreTime.length == 12){
        if(v2.test(data.scoreTime)){
          const response =  await this.putApi("/api/v1/promoter/score", data);
          if(response.success == 1){
            this.filteredScores_();
          }
        }else{
          this.alertNoFormat = true
          this.filteredScores = ''
          this.filteredScores_();
        }
      }else if(data.scoreTime.length == 11){
        if(v3.test(data.scoreTime)){
          const response =  await this.putApi("/api/v1/promoter/score", data);
          if(response.success == 1){
            this.filteredScores_();
          }
        }else{
          this.alertNoFormat = true
          this.filteredScores = ''
          this.filteredScores_();
        }
      }else if(data.scoreTime.length == 10){
        if(v4.test(data.scoreTime)){
          const response =  await this.putApi("/api/v1/promoter/score", data);
          if(response.success == 1){
            this.filteredScores_();
          }
        }else{
          this.alertNoFormat = true
          this.filteredScores = ''
          this.filteredScores_();
        }
      }else{
        this.alertNoFormat = true
        this.filteredScores = ''
        this.filteredScores_();
      }

      
    },
    alertColor(){
       this.alert= false
       var class1= document.getElementsByClassName('colorAlert');
        class1[0].classList.remove("colorAlert")
    },
    async changeBackupAutomatic(newValue) {
        let data = {
          setting: "scoreBackupAutomatically",
          value: newValue ? 1 : 0
        }
        const response =  await this.putApi("/api/v1/promoter/setting", data);

        if(!response.success) {
          this.error = this.$t("results.analysis.error_saving");
          this.bandBackupAutomatic = !newValue;
        }
    },
    async getBackupAutomatic() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/setting/scoreBackupAutomatically" 
      );
      if(response.success) {
        const res = Number.parseInt(response.message);
        this.backupAutomatic = res;
      }
    },
    confirmProcessBackups() {
      this.confirmBand = true;
      this.alert = false;
    },
    async processBackups() {
      this.loadingProcess = true;
      this.confirmBand = false;
      if(this.selectedRaces.valor){
        this.alert=false      
      const response = await this.api(
        "post",
        "/api/v1/promoter/race/processBackupRace",
          { raceId: this.selectedRaces.valor }
      );
      this.loadingProcess = false;
      if(!response.success) {
        if(response.message == "backup-already-queued") {
          this.error = this.$t("results.analysis.error.process_backups");
        } else {
          this.error = this.$t("results.analysis.error.failed_process_backup");
        }
        
    }
  }
      else{
        this.loadingProcess = false;
        this.alert=true
        var class1 = document.getElementsByClassName('racesCompClass')[0].getElementsByClassName('v-input__slot');
        class1[0].className+=" colorAlert"
  }
    }
  }
};
</script>

  
<style>
/*Tabulator styles*/
.tabulator-col[tabulator-field="edit"],
.tabulator-col[tabulator-field="edit"],
.tabulator-col-group-cols {
  height: 0px !important;
  min-height: 0px !important;
}
.tabulator-col[tabulator-field="edit"],
.tabulator-col[tabulator-field="edit"] {
  border: 0px !important;
}
.tabulator-menu {
    height: 300px;
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    font-size: 14px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 10000;
}
.tabulator-menu .tabulator-menu-item {
    position: relative;
    box-sizing: border-box;
    padding: 5px 10px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.tabulator-menu-item i {
    color: #3FB449;
}
.tabulator .tabulator-header .tabulator-col {
  display: inline-block;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-right: 1px solid #aaa;
  background-color: #222;
  text-align: left;
  vertical-align: bottom;
  overflow: hidden;
  height: auto !important;
}
/*end tabulator styles */
  .bigfilters{
    padding: 0px 0px 0px 2%;
  }
@media (min-width: 961px) {
  .tabulador{
    margin-left: 20% !important;
    margin-right: 34% !important;
    display: block;
  }
}
@media (min-width: 768px) {
  .button{
    margin-left: 20%;
  }
  .notifications-zone{
    margin-left: 20% !important;
    margin-right: 20%;
    top: 16% !important;
    left: 50% !important;
    width: 28% !important;
  }
  
}
@media (max-width: 768px) {
  .row{
    display: -webkit-box;
  }

}
.pag1{
  margin-top:3% !important;
}
  .btn1 {
    text-transform: none;
  }
  .btn2 {
    text-transform: none;
  }
  .add{
    justify-content: end;
  }
  .tabulator .tabulator-tableHolder .tabulator-placeholder span {
    color: black !important
  }
  
  .edit{
    justify-content: right;
    align-items: center;
  }
  .button_add{
    text-transform: none;
  }
  .v-tab {
    background-color:transparent;
    color: var(--v-primary-darken2) !important;
    font-weight: bold;
  }
  .v-card__title{
    background:none !important;
  }
  .button1{
    background-color: var(--v-lighten-base) !important;
    position: absolute;
    margin: -16px;
    width: 101%;
  }
  .pag2 .v-data-table-header-mobile__wrapper {
    margin-top: 12px;
  }

@media (max-width: 1530px) and (min-width: 760px){
  .v-alert{
    width: 380px !important;
  }

}
.v-alert{
  margin: auto !important;
}
    
</style>
  